import React from "react";
const WildcardsLoaderGif = "/img/loading.gif";

const WildcardsLoader = () => {
  return <img src={WildcardsLoaderGif} width={"30px"} alt="loading" />;
};

export default WildcardsLoader;
